import Announcement from './announcement/Announcement'

export default function AnnouncementPage() {
  return <Announcement />
}
